import script from "./PlayerBannedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerBannedPage.vue?vue&type=script&setup=true&lang=js"

import "./PlayerBannedPage.vue?vue&type=style&index=0&id=05eac1a1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05eac1a1"]])

export default __exports__